import React from 'react';

import { useGetTravelCompensationType } from 'queries';

import { Arrangement } from '../types';

import { isNotNil } from 'utils/ramdaUtils';

import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import DrawerFormSkeleton from 'components/shared/CRUD/components/DrawerFormSkeleton';
import { LoadingError } from 'components/shared/LoadingError/LoadingError';

import { useGetArrangement } from '../hooks/useSaveArrangement';
import { ArrangementForm } from './ArrangementForm';

export const CreateArrangementDrawer: React.FC<
  FormComponentProps<Arrangement>
> = ({ handleClose, rowId, rows = [] }) => {
  const { isFetching, data, error, refetch } = useGetArrangement(
    isNotNil(rowId) ? Number(rowId) : rowId
  );

  const { data: arrangementTypes } = useGetTravelCompensationType();

  return isFetching ? (
    <DrawerFormSkeleton count={3} />
  ) : error ? (
    <LoadingError reFetch={refetch} />
  ) : (
    <ArrangementForm
      handleClose={handleClose}
      rowData={data as Arrangement}
      rows={rows}
      arrangementTypes={arrangementTypes ?? []}
    />
  );
};
